export const selectHasExchanegRates = state => state.exchangeRates.data.length > 0;

export const selectExchangeRates = state => state.exchangeRates.data;

export const selectExchangeRate = state =>
	state.exchangeRates.data.find(({ code }) => code === state.exchangeRates.currencyCode);
